import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Shield, FileText, HelpCircle, Heart, Instagram, Facebook, Youtube, ShoppingCart } from 'lucide-react';
import { FooterModal } from './FooterModal';
type ModalType = 'soporte' | 'contacto' | 'terminos' | 'privacidad' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#1e3a5f] text-gray-300" data-id="element-129">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-130">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-131">
            {/* Brand Section */}
            <div data-id="element-132">
              <div className="mb-4" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/vNvoQX3M4Pm4so4ojSbXDF/logo_finanzas_faciles_solo_texto.png" alt="Finanzas Fáciles" className="h-12 w-auto" data-id="element-134" />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-135">
                Transformando mujeres en expertas de su propio dinero. Un método
                probado de 30 días para tomar el control financiero sin presión.
              </p>
              <div className="flex items-center gap-2 text-[#d4a574] text-sm mb-6" data-id="element-136">
                <Heart className="w-4 h-4 fill-current" data-id="element-137" />
                <span className="font-medium" data-id="element-138">
                  Hecho con pasión para emprendedoras
                </span>
              </div>

              {/* Payment Button */}
              <motion.a href="https://mikioscodigital.com/cart/51754595811609:1" whileHover={{
              scale: 1.1,
              y: -6
            }} whileTap={{
              scale: 0.92,
              y: 2
            }} className="group relative inline-block" style={{
              perspective: '1000px'
            }} data-id="element-139">
                {/* Enhanced Multiple 3D Shadow Layers - More Luminous */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#f4d03f] to-[#d4a574] rounded-2xl translate-y-4 blur-2xl opacity-70 group-hover:translate-y-5 group-hover:opacity-90 transition-all duration-300" data-id="element-140" />
                <div className="absolute inset-0 bg-gradient-to-br from-[#d4a574] to-[#c29463] rounded-2xl translate-y-2 blur-xl opacity-60 group-hover:translate-y-3 group-hover:opacity-80 transition-all duration-300" data-id="element-141" />
                <div className="absolute inset-0 bg-[#f4d03f] rounded-2xl translate-y-1 blur-lg opacity-50 group-hover:translate-y-2 group-hover:opacity-70 transition-all duration-300" data-id="element-142" />

                {/* Pulsing Outer Glow Animation */}
                <motion.div className="absolute inset-0 rounded-2xl" animate={{
                boxShadow: ['0 0 40px rgba(244, 208, 63, 0.6), 0 0 80px rgba(212, 165, 116, 0.4)', '0 0 60px rgba(244, 208, 63, 0.8), 0 0 120px rgba(212, 165, 116, 0.6)', '0 0 40px rgba(244, 208, 63, 0.6), 0 0 80px rgba(212, 165, 116, 0.4)']
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-143" />

                {/* Main 3D Button - Ultra Bright */}
                <div className="relative bg-gradient-to-br from-[#f4d03f] via-[#ffd700] to-[#d4a574] p-[4px] rounded-2xl shadow-2xl group-hover:shadow-[0_30px_60px_rgba(244,208,63,0.8)] transition-all duration-300" data-id="element-144">
                  {/* Enhanced Inner glow */}
                  <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-black/5 rounded-2xl" data-id="element-145" />

                  <div className="relative bg-gradient-to-br from-[#f4d03f] via-[#ffd700] to-[#d4a574] rounded-2xl overflow-hidden" data-id="element-146">
                    {/* Ultra Bright animated shine effect */}
                    <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent" animate={{
                    x: ['-100%', '200%']
                  }} transition={{
                    duration: 2,
                    repeat: Infinity,
                    repeatDelay: 1,
                    ease: 'easeInOut'
                  }} data-id="element-147" />

                    {/* Multiple radial highlights for extra luminosity */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-3/4 bg-gradient-radial from-white/50 to-transparent blur-2xl" data-id="element-148" />
                    <div className="absolute top-1/4 left-1/4 w-1/2 h-1/2 bg-white/30 rounded-full blur-3xl" data-id="element-149" />

                    {/* Sparkle effect */}
                    <motion.div className="absolute top-2 right-2 w-2 h-2 bg-white rounded-full" animate={{
                    opacity: [0, 1, 0],
                    scale: [0.5, 1, 0.5]
                  }} transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    repeatDelay: 0.5
                  }} data-id="element-150" />
                    <motion.div className="absolute bottom-3 left-3 w-1.5 h-1.5 bg-white rounded-full" animate={{
                    opacity: [0, 1, 0],
                    scale: [0.5, 1, 0.5]
                  }} transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    repeatDelay: 1
                  }} data-id="element-151" />

                    <div className="relative px-10 py-6 flex items-center justify-center gap-4 group-hover:scale-[1.03] transition-transform duration-300" data-id="element-152">
                      <motion.div whileHover={{
                      rotate: [0, -15, 15, -15, 0]
                    }} transition={{
                      duration: 0.6
                    }} data-id="element-153">
                        <ShoppingCart className="w-8 h-8 text-[#1e3a5f] drop-shadow-lg" data-id="element-154" />
                      </motion.div>
                      <div className="flex flex-col items-start" data-id="element-155">
                        <span className="text-[#1e3a5f] font-bold text-xl leading-tight drop-shadow-md" data-id="element-156">
                          Sí Quiero Mi Pack Premium
                        </span>
                        <span className="text-[#1e3a5f] font-bold text-xl leading-tight drop-shadow-md" data-id="element-157">
                          Ahora Mismo!!!
                        </span>
                        <span className="text-[#1e3a5f]/90 text-sm font-bold mt-1 drop-shadow-sm" data-id="element-158">
                          🔥 Solo $9.95 USD - Oferta Limitada
                        </span>
                      </div>
                    </div>

                    {/* Enhanced bottom edge highlight */}
                    <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-t from-black/30 to-transparent" data-id="element-159" />
                  </div>
                </div>

                {/* Ultra bright outer glow on hover */}
                <motion.div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
                boxShadow: '0 0 60px rgba(244, 208, 63, 0.8), 0 0 120px rgba(255, 215, 0, 0.6), 0 0 180px rgba(212, 165, 116, 0.4)'
              }} data-id="element-160" />
              </motion.a>
            </div>

            {/* Quick Links */}
            <div data-id="element-161">
              <h4 className="text-white font-bold text-lg mb-6" data-id="element-162">
                Enlaces Rápidos
              </h4>
              <ul className="space-y-3" data-id="element-163">
                <li data-id="element-164">
                  <button onClick={() => setActiveModal('soporte')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-165">
                    <HelpCircle className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-166" />
                    <span data-id="element-167">Centro de Soporte</span>
                  </button>
                </li>
                <li data-id="element-168">
                  <button onClick={() => setActiveModal('contacto')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-169">
                    <Mail className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-170" />
                    <span data-id="element-171">Contacto</span>
                  </button>
                </li>
                <li data-id="element-172">
                  <button onClick={() => setActiveModal('terminos')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-173">
                    <FileText className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-174" />
                    <span data-id="element-175">Términos y Condiciones</span>
                  </button>
                </li>
                <li data-id="element-176">
                  <button onClick={() => setActiveModal('privacidad')} className="flex items-center gap-2 text-gray-400 hover:text-[#d4a574] transition-colors group" data-id="element-177">
                    <Shield className="w-4 h-4 group-hover:scale-110 transition-transform" data-id="element-178" />
                    <span data-id="element-179">Política de Privacidad</span>
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div data-id="element-180">
              {/* Email */}
              <div className="mb-6" data-id="element-181"></div>

              {/* Social Media */}
              <div data-id="element-182">
                <p className="text-gray-400 text-sm mb-4" data-id="element-183">Mantente conectada</p>
                <div className="flex gap-4" data-id="element-184">
                  {/* Instagram - Premium 3D Gold Button */}
                  <a href="https://www.instagram.com/reel/DSL77_7jSQN/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" target="_blank" rel="noopener noreferrer" className="group relative" style={{
                  perspective: '1000px'
                }} aria-label="Instagram" data-id="element-185">
                    {/* Multiple 3D Shadow Layers */}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#8b6f47] to-[#5d4a2f] rounded-xl translate-y-3 blur-lg opacity-40 group-hover:translate-y-4 group-hover:opacity-60 transition-all duration-300" data-id="element-186" />
                    <div className="absolute inset-0 bg-gradient-to-br from-[#c29463] to-[#8b6f47] rounded-xl translate-y-2 blur-md opacity-50 group-hover:translate-y-3 group-hover:opacity-70 transition-all duration-300" data-id="element-187" />
                    <div className="absolute inset-0 bg-[#d4a574] rounded-xl translate-y-1 blur-sm opacity-40 group-hover:translate-y-2 transition-all duration-300" data-id="element-188" />

                    {/* Main 3D Button */}
                    <div className="relative w-14 h-14 bg-gradient-to-br from-[#f4d03f] via-[#d4a574] to-[#c29463] p-[2px] rounded-xl shadow-2xl group-hover:shadow-[0_20px_40px_rgba(212,165,116,0.6)] transition-all duration-300 group-hover:-translate-y-1.5 group-hover:scale-110 group-active:translate-y-0.5 group-active:scale-95" data-id="element-189">
                      {/* Inner glow */}
                      <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-black/10 rounded-xl" data-id="element-190" />

                      <div className="relative w-full h-full bg-gradient-to-br from-[#f4d03f] via-[#d4a574] to-[#c29463] rounded-xl overflow-hidden flex items-center justify-center" data-id="element-191">
                        {/* Animated shine effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-192" />

                        {/* Radial highlight */}
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1/2 bg-gradient-radial from-white/40 to-transparent blur-md" data-id="element-193" />

                        <Instagram className="w-6 h-6 text-white drop-shadow-lg relative z-10" data-id="element-194" />

                        {/* Bottom edge shadow */}
                        <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-t from-black/30 to-transparent" data-id="element-195" />
                      </div>
                    </div>

                    {/* Outer glow on hover */}
                    <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
                    boxShadow: '0 0 30px rgba(244, 208, 63, 0.5)'
                  }} data-id="element-196" />
                  </a>

                  {/* Facebook - Premium 3D Gold Button */}
                  <a href="https://www.facebook.com/share/v/16fep31j43/" target="_blank" rel="noopener noreferrer" className="group relative" style={{
                  perspective: '1000px'
                }} aria-label="Facebook" data-id="element-197">
                    {/* Multiple 3D Shadow Layers */}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#8b6f47] to-[#5d4a2f] rounded-xl translate-y-3 blur-lg opacity-40 group-hover:translate-y-4 group-hover:opacity-60 transition-all duration-300" data-id="element-198" />
                    <div className="absolute inset-0 bg-gradient-to-br from-[#c29463] to-[#8b6f47] rounded-xl translate-y-2 blur-md opacity-50 group-hover:translate-y-3 group-hover:opacity-70 transition-all duration-300" data-id="element-199" />
                    <div className="absolute inset-0 bg-[#d4a574] rounded-xl translate-y-1 blur-sm opacity-40 group-hover:translate-y-2 transition-all duration-300" data-id="element-200" />

                    {/* Main 3D Button */}
                    <div className="relative w-14 h-14 bg-gradient-to-br from-[#f4d03f] via-[#d4a574] to-[#c29463] p-[2px] rounded-xl shadow-2xl group-hover:shadow-[0_20px_40px_rgba(212,165,116,0.6)] transition-all duration-300 group-hover:-translate-y-1.5 group-hover:scale-110 group-active:translate-y-0.5 group-active:scale-95" data-id="element-201">
                      {/* Inner glow */}
                      <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-black/10 rounded-xl" data-id="element-202" />

                      <div className="relative w-full h-full bg-gradient-to-br from-[#f4d03f] via-[#d4a574] to-[#c29463] rounded-xl overflow-hidden flex items-center justify-center" data-id="element-203">
                        {/* Animated shine effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-204" />

                        {/* Radial highlight */}
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1/2 bg-gradient-radial from-white/40 to-transparent blur-md" data-id="element-205" />

                        <Facebook className="w-6 h-6 text-white drop-shadow-lg relative z-10" data-id="element-206" />

                        {/* Bottom edge shadow */}
                        <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-t from-black/30 to-transparent" data-id="element-207" />
                      </div>
                    </div>

                    {/* Outer glow on hover */}
                    <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
                    boxShadow: '0 0 30px rgba(244, 208, 63, 0.5)'
                  }} data-id="element-208" />
                  </a>

                  {/* YouTube - Premium 3D Gold Button */}
                  <a href="https://youtube.com/shorts/yVldmTz5qMw?si=Y13kSTCYu6Sg3oKG" target="_blank" rel="noopener noreferrer" className="group relative" style={{
                  perspective: '1000px'
                }} aria-label="YouTube" data-id="element-209">
                    {/* Multiple 3D Shadow Layers */}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#8b6f47] to-[#5d4a2f] rounded-xl translate-y-3 blur-lg opacity-40 group-hover:translate-y-4 group-hover:opacity-60 transition-all duration-300" data-id="element-210" />
                    <div className="absolute inset-0 bg-gradient-to-br from-[#c29463] to-[#8b6f47] rounded-xl translate-y-2 blur-md opacity-50 group-hover:translate-y-3 group-hover:opacity-70 transition-all duration-300" data-id="element-211" />
                    <div className="absolute inset-0 bg-[#d4a574] rounded-xl translate-y-1 blur-sm opacity-40 group-hover:translate-y-2 transition-all duration-300" data-id="element-212" />

                    {/* Main 3D Button */}
                    <div className="relative w-14 h-14 bg-gradient-to-br from-[#f4d03f] via-[#d4a574] to-[#c29463] p-[2px] rounded-xl shadow-2xl group-hover:shadow-[0_20px_40px_rgba(212,165,116,0.6)] transition-all duration-300 group-hover:-translate-y-1.5 group-hover:scale-110 group-active:translate-y-0.5 group-active:scale-95" data-id="element-213">
                      {/* Inner glow */}
                      <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-black/10 rounded-xl" data-id="element-214" />

                      <div className="relative w-full h-full bg-gradient-to-br from-[#f4d03f] via-[#d4a574] to-[#c29463] rounded-xl overflow-hidden flex items-center justify-center" data-id="element-215">
                        {/* Animated shine effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-216" />

                        {/* Radial highlight */}
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1/2 bg-gradient-radial from-white/40 to-transparent blur-md" data-id="element-217" />

                        <Youtube className="w-6 h-6 text-white drop-shadow-lg relative z-10" data-id="element-218" />

                        {/* Bottom edge shadow */}
                        <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-t from-black/30 to-transparent" data-id="element-219" />
                      </div>
                    </div>

                    {/* Outer glow on hover */}
                    <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
                    boxShadow: '0 0 30px rgba(244, 208, 63, 0.5)'
                  }} data-id="element-220" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 bg-[#152d47]" data-id="element-221">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-222">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-223">
              <div className="flex items-center gap-6 text-xs text-gray-400" data-id="element-224">
                <p data-id="element-225">
                  © {new Date().getFullYear()} Finanzas Fáciles para Mujeres •
                  Todos los Derechos Reservados
                </p>
              </div>
              <div className="flex items-center gap-4 text-xs" data-id="element-226">
                <div className="flex items-center gap-2 text-green-400" data-id="element-227">
                  <Shield className="w-4 h-4" data-id="element-228" />
                  <span data-id="element-229">Pago Seguro</span>
                </div>
                <div className="flex items-center gap-2 text-[#d4a574]" data-id="element-230">
                  <span className="w-2 h-2 bg-[#d4a574] rounded-full animate-pulse" data-id="element-231"></span>
                  <span data-id="element-232">Entrega Inmediata</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-[#0f1f33] border-t border-white/5" data-id="element-233">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-234">
            <p className="text-xs text-gray-500 leading-relaxed text-center" data-id="element-235">
              <strong className="text-gray-400" data-id="element-236">
                Descargo de responsabilidad:
              </strong>{' '}
              Este producto tiene fines educativos e informativos únicamente. No
              constituye asesoría financiera personalizada. Los resultados
              pueden variar según el esfuerzo y la situación individual de cada
              persona. No garantizamos resultados específicos ni ganancias
              monetarias.
            </p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      {activeModal && <FooterModal isOpen={!!activeModal} onClose={() => setActiveModal(null)} type={activeModal} data-id="element-237" />}
    </>;
}